<template>

    <v-container justify-start>
      <span><router-link :to="{name:'Проекты'}">Проекты</router-link></span> <span>/<b> Проект </b></span>

      <v-divider class="mt-3"></v-divider>

      <v-layout row wrap my-2 align-center justify-center>
       <v-flex class="xs12 md9">
          <v-card class="elevation-1">
            <v-card-title>
                <h2>{{Project.name}}</h2>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>Статус:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{Project.status}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Объем закупки:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{Project.quantity}} из {{Project.maxQuantity}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Сумма:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{Project.sum}} из {{Project.maxSum}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Плановая дата старта:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{Project.dateStart}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Плановая дата закрытия:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{Project.dateExpected}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Ожидаемая прибыль (%):</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{Project.profitExpected}}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="Project.my">
                  <h3>Мои инвестиции</h3>
                </v-list-tile>
                <v-list-tile v-if="Project.my">
                  <v-list-tile-content>Инвестированная сумма:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{Project.sumMy}}</v-list-tile-content>
                </v-list-tile>
            </v-list>

          </v-card>
        </v-flex>
        <v-flex class="xs12 md8" my-4 v-if="Project.status=='открыт'">
          <v-card class="elevation-1">
            <v-card-title>
                <h4>Инвестирование</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <h5>Вы можете инвестировать в этот проект максимально {{Project.maxSum-Project.sum}} руб.</h5>
              <v-layout row wrap>
                <v-flex xs-4><v-text-field v-model="sum" label="Сумма" type="number" :rules="[rules.required, rules.positive]" class="suminput"></v-text-field></v-flex>
                <v-flex xs-8><v-btn color="success" @click="invest()">Инвестировать</v-btn></v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>

      <!-- snackbar -->
      <v-snackbar
        :timeout="4000"
        :top="true"
        :bottom="false"
        :right="true"
        :left="false"
        :multi-line="false"
        :vertical="true"
        v-model="snackbar">
        {{ message }}
        <v-btn flat color="pink" @click.native="snackbar = false">Закрыть</v-btn>
      </v-snackbar>

    </v-container>
</template>

<script>

export default {
   components:{
  },
    props: ["id"],
    created () {
      console.log('projectCard.created',this.id)
      var Pr = this.$store.getters["projects/projectByID"](this.id)
      this.Project = Pr
    },
    mounted () {
    },
    computed: {
    },
    data () {
        return {
          Project: {},
          sum: 0,
          message: '',
          snackbar: false,
          rules: {
              required: value => !!value || 'Обязательное поле.',
              positive: v => v>0 || 'Только положительное',
              emailMatch: () => ('The email and password you entered don\'t match'),
            },

        }
    },
    methods: {
      invest() {
        let max = this.$store.getters['account/account'].sum_balance
        if (this.sum>max) {
          this.message = 'Для инвестирования не хватает суммы на балансе'
          this.snackbar = true
          this.sum = max
          return
        }
        console.log('invest');
        this.$store.dispatch('projects/investToProject',{sum:this.sum, projectID: this.Project.id}).then(res=>{
          console.log('investing complete',res);
          this.$router.push({name:'Проекты'})
        })

      }
    }
}
</script>

<style scoped>
    .suminput {
      width: 150px;
    }
</style>



// WEBPACK FOOTER //
// ProjectCard.vue?5cae27c2